module.exports = __webpack_public_path__ + "static/media/3@2x.0a8eb9fa.png";